import React, { useEffect, useState } from 'react';
import Main from '../../Main';
import { Col, Dropdown, Row } from 'react-bootstrap';
import columnFilter from '../../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../../assets/images/CustomerManagement/valueFilter.svg'
import '../../../assets/css/dashboard.scss'
import '../../../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import SbCancelBtn, { SbAddBtn, SbFilterBtn } from '../../Buttons/Buttons';
import Select from 'react-select';
import AddFinancialApproval from './AddFinancialApproval';
import FinancialApprovalTable from './FinancialApprovalTable';
import Download from '../../MainSection/Download/Download';
import { useNavigate, useParams } from 'react-router-dom';
import FinancialColumnFilter from './FinancialColumnFilter';
import FinancialValueFilter from './FinancialValueFilter';
import { useDispatch, useSelector } from 'react-redux';
import { loadSettingsFinancialApprovalData, loadSettingsSingleFinancialApprovalData, postFinancialApprovalDatas } from '../../../redux/action';
import { ADDED_BY_ID } from '../../../Constants';
import * as HeaderAuthentication from '../../HeaderAuthentication'

const statusOptions = [
    { value: 54, label: "Active" },
    { value: 55, label: "Inactive" }
]

const FinancialApproval = () => {

    let dispatch = useDispatch();
    const { id: userRefId } = useParams();

    const { financialApprovalData } = useSelector((state) => state.data);
    const { singleFinancialApprovalData } = useSelector((state) => state.data);
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const PreviousCompanyID = JSON.parse(sessionStorage.getItem('PreviousCompanyID'));

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [finanacialApprovalId, setFinancialApprovalId] = useState("");
    const [loading, setLoading] = useState(true);
    const [selectedColumns, setSelectedColumns] = useState([
        "APPROVAL LEVEL", "TITLE", "DEPARTMENT", "APPROVAL CONDITIONS", "LOW THRESHOLD",
        "NOT TO EXCEED THRESHOLD", "STATUS", "ACTION"
    ]);
    const [selectedStatusID, setSelectedStatusID] = useState(null);
    const [dataLoading, setDataLoading] = useState(false);

    const handleStatusSelection = (selectedOption) => {
        if (selectedOption) {
            const statusID = selectedOption.value;  // Extract StatusID (assuming 'value' is the StatusID)
            setSelectedStatusID(statusID);  // Store StatusID in state
            financialApproval(statusID);  // Call API with both StatusID and current RoleID
        }
    };

    useEffect(() => {
        if (userRefId) {
            dispatch(loadSettingsSingleFinancialApprovalData(setDataLoading, userRefId));
        } else {
            financialApproval();
        }
    }, [userRefId]);

    const financialApproval = (statusID) => {
        dispatch(loadSettingsFinancialApprovalData(setLoading, statusID));
    }

    useEffect(() => {
        financialApproval();
    }, []);

    useEffect(() => {
        dispatch(loadSettingsSingleFinancialApprovalData(setDataLoading));
    }, [])

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };
    const handleOpenModal = (financialApprovalID) => {
        setIsModalOpen(true);
        if (financialApprovalID) {
            dispatch(loadSettingsSingleFinancialApprovalData(setDataLoading, financialApprovalID));
            setFinancialApprovalId(financialApprovalID);
        } else {
            setFinancialApprovalId("");
        }
    };

    const handleCloseModal = () => {
        setFinancialApprovalId("");
        dispatch(loadSettingsSingleFinancialApprovalData(setDataLoading, null));
        setIsModalOpen(false);
    };
    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    }

    const handleStatusChange = (customer, statusLabel) => {
        const statusID = statusLabel === "Active" ? 54 : 55; // 24 for Active, 25 for Inactive

        // console.log(customer, 'customer')
        const data = {
            FinancialApprovalID: customer.FinancialApprovalID,
            LevelID: customer.FinancialApprovalLevelID,
            Title: customer.FinancialApprovalTitle,
            DepartmentID: customer.FinancialApprovalDepartmentID,
            Order: customer.FinancialApprovalOrder,
            Condition: customer.FinancialApprovalCondition,
            StatusID: statusID,
            LowThreshold: customer.FinancialApprovalLowThreshold,
            NotToExceedThreshold: customer.FinancialApprovalNotToExceedThreshold,
            AddedByID: ADDED_BY_ID
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        // Dispatch the action to update the department status
        dispatch(postFinancialApprovalDatas(requestOption, handleCloseModal, financialApproval, customer.FinancialApprovalID));
        // console.log(data, 'data'); // For debugging purposes
    };

    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };

    const handleColumnSelectionChange = (updatedSelectedColumns) => {
        setSelectedColumns(updatedSelectedColumns); // Update the selected columns
    };

    const handleClearFilters = () => {
        setSelectedStatusID(null);
        financialApproval();
    }

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Settings / Financial Approval"
                        onBackClick={handleBack}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Financial Approval</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <div className='customermanagement-header-btns filter-btn'>
                                    <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                <Col md={3} className='filters-col'>
                                    <Select
                                        className="react-select-container complaint-status-select"
                                        classNamePrefix="react-select"
                                        placeholder="Search Status"
                                        options={statusOptions}
                                        style={{ width: "100%" }}
                                        value={selectedStatusID ? statusOptions.find(status => status.value === selectedStatusID) : null}
                                        onChange={(selectedOption) => handleStatusSelection(selectedOption)}
                                    />
                                </Col>
                                <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                                {(signInDetails[0]?.SignInType !== 'ClientAdmin' || PreviousCompanyID) && <SbAddBtn btnName="Add" onClickEffect={() => { handleOpenModal("") }} />}
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <FinancialApprovalTable
                                handleOpenModal={handleOpenModal}
                                handleViewDetails={handleViewDetails}
                                financialApprovalData={financialApprovalData}
                                loading={loading}
                                handleStatusChange={handleStatusChange}
                                selectedColumns={selectedColumns}
                                signInDetails={signInDetails}
                                PreviousCompanyID={PreviousCompanyID}
                                singleFinancialApprovalData={singleFinancialApprovalData}
                                userRefId={userRefId}
                            />
                        </div>
                    </div>
                </div>
            </Main>
            {
                isModalOpen && <AddFinancialApproval
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                    financialApproval={financialApproval}
                    singleFinancialApprovalData={singleFinancialApprovalData}
                    finanacialApprovalId={finanacialApprovalId}
                    dataLoading={dataLoading}
                />
            }
            {showColumnFilterModal && (
                <FinancialColumnFilter
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                    selectedColumns={selectedColumns}
                    handleSaveColumns={handleColumnSelectionChange}
                />
            )}
            {showValueFilterModal && (
                <FinancialValueFilter
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                />
            )}
            {/* {showCustomerViewDetails && (
                <CustomerViewDetails
                    showCustomerViewDetails={showCustomerViewDetails}
                    handleCloseViewDetails={handleCloseViewDetails}
                />
            )} */}
        </div >
    );
};

export default FinancialApproval;